<template>
  <v-layout>
    <div class="col">
      <div class="head-page-title">
        <h1 class="main-title">Bestellingen</h1>
        <span class="sub-title">Ordernummer {{ $route.params.orderId }}</span>
      </div>
      <div class="panel">
        <div class="row">
          <div class="small-12 columns">
            <div class="datatable-wrapper">
              <div class="dataTables_wrapper dt-foundation no-footer">
                <table class="datatable datatable-row-click dataTable no-footer" role="grid"
                       style="width: 800px;">
                  <thead>
                    <table-header :order-by="orderBy"
                                  :order-direction="orderDirection"
                                  :columns="headerColumns"
                                  translation-prefix="orderItem.headerColumns."
                                  @orderingChanged="setOrderingAndLoadData"/>
                  </thead>
                  <tbody>
                    <tr is="order-item-list-item"
                        v-for="orderItem in orderItems"
                        :order-item="orderItem"
                        :key="orderItem.id"/>
                    <tr v-if="!orderItems || orderItems.length === 0">
                      <td colspan="5">Geen resultaten</td>
                    </tr>
                  </tbody>
                </table>
                <div class="bottom">
                  <div class="dataTables_paginate paging_full_numbers">
                    <order-items-list-paginator :page-size="pageSize" @paginationChanged="loadData"/>
                  </div>
                </div>
                <div class="clear"/>
              </div>
            </div>

          </div>
        </div>
      </div>
      <router-link id="back-to-overview" :to="{ name: 'order'}" class="button button-action alt">Terug naar besteloverzicht</router-link>
    </div>
  </v-layout>
</template>

<script>
import VLayout from '../layouts/Default'
import { mapState } from 'vuex'
import 'bower/foundation/js/foundation.js'
import OrderItemsListPaginator from '../components/orderItems/OrderItemsListPaginator'
import OrderItemListItem from '../components/orderItems/OrderItemListItem'
import {
  SET_ORDER_ITEMS_PAGE_SIZE,
  SET_ORDER_ITEMS_ORDER_BY,
  SET_ORDER_ITEMS_ORDER_DIRECTION
} from '../store/modules/order-items/mutation-types'
import showAlertErrorHandler from '../mixins/show-alert-error-handler'
import {buildTableHeaderColumn} from '../types/table-header-column'
import TableHeader from '../components/tableHeader/TableHeader'

export default {
  name: 'OrderDetailsPage',
  components: {
    TableHeader,
    OrderItemsListPaginator,
    OrderItemListItem,
    VLayout
  },
  mixins: [showAlertErrorHandler],
  data: () => {
    return {
      selectedOrderId: '',
      headerColumns: [
        buildTableHeaderColumn('orderItemType', '17.5%'),
        buildTableHeaderColumn('engravedId', '22.5%'),
        buildTableHeaderColumn('tariffName', '40%'),
        buildTableHeaderColumn('dateEffective', '10%'),
        buildTableHeaderColumn('orderStatus', '10%')
      ]
    }
  },
  computed: {
    ...mapState({
      orderItems: state => state.orderItems.orderItemsForCurrentFilter,
      pageSize: state => state.orderItems.orderItemsPageSize,
      currentPage: state => state.orderItems.orderItemsCurrentPageNumber,
      orderBy: state => state.orderItems.orderItemsOrderBy,
      orderDirection: state => state.orderItems.orderItemsOrderDirection
    })
  },
  methods: {
    loadData: async function () {
      try {
        await this.$store.dispatch('orderItems/loadOrderItems', this.$route.params.orderId)
      } catch (error) {
        this.showAlertForErrorAndRedirectToRoute(error, {}, {401: {name: 'login'}})
      }
    },
    setPageSizeAndLoadData: function (value) {
      value = parseInt(value)
      this.$store.commit(`order/${SET_ORDER_ITEMS_PAGE_SIZE}`, value)
      this.loadData()
    },
    setOrderingAndLoadData (ordering) {
      this.$store.commit(`orderItems/${SET_ORDER_ITEMS_ORDER_BY}`, ordering.orderBy)
      this.$store.commit(`orderItems/${SET_ORDER_ITEMS_ORDER_DIRECTION}`, ordering.orderDirection)
      this.loadData()
    }
  }
}
</script>

<style>
  #back-to-overview {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/OrderDetailsPage.vue